<template>
  <el-container direction="vertical" style="height: auto" id="orderPaymentType">
    <el-row>
      <el-col :span="16" :push="4">
        <el-card class="box-card-one">
          <div class="topUnit">
            <i class="el-icon-circle-check"></i>
            <div class="header-left">
              <p class="header-col-p-big">订单已提交成功，请尽快付款！</p>
              <p class="header-col-p-small">请在起保日期<span
                class="header-col-p-span">{{orderData.effectiveDate}}</span>前完成支付，否则订单会自动取消</p>
              <div class="header-left" style="padding-top: 20px">
                <p class="header-row-col-div-p">产品名称：<span>{{sellProductName}}</span></p>
                <p class="header-row-col-div-p">订单编号：<span>{{orderData.orderIdNum}}</span></p>
                <p class="header-row-col-div-p">应付金额：<span
                  class="header-col-p-span">{{orderData.payMoney}}</span><span class="header-col-p-span">元</span></p>
                <p class="header-row-col-div-p">订单详情：<a style="display: inline-block" class="header-col-p-span" @click="onSee">点击查看</a></p>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="16" :push="4">
        <el-card class="box-card-two">
          <div class="bottomUnit">
            <p class="header-row-col-div-p-big">请选择以下两种中的任意一种方式付款</p>
            <div>
              <div class="header-row-col-div-span">支付方式：</div>
              <el-radio-group v-model="radio" @change="getWxPayCode">
                <el-radio :label=1 class="header-radio">银行转账</el-radio>
                <el-radio :label=2 class="header-radio">微信/支付宝</el-radio>
              </el-radio-group>
            </div>
            <div v-if="radio === 1">
              <div>
                <div class="header-row-col-div-span">收款人账户：</div>
                <div>中国人寿财产保险股份有限公司深圳市分公司</div>
              </div>
              <div>
                <div class="header-row-col-div-span">收款人账号：</div>
                <div>7559 1541 4510 666</div>
              </div>
              <div>
                <div class="header-row-col-div-span">开户行：</div>
                <div>招商银行深圳分行营业部</div>
              </div>
              <div>
                <div class="header-row-col-div-span">支付证明：</div>
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  accept="jpg,jpeg,png,bmp"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" alt="">
                  <div v-else class="uploadImg"/>
                </el-upload>
                <el-card v-if="this.$$.isValidObj(extraData)" class="box-card">
                  <div style="font-size: 20px;font-weight: bold;margin-bottom: 10px">识别结果</div>
                  <div v-for="o in extraData" :key="o" class="item">
                    <div>{{ o.toString().split(":")[0] }}:</div>
                    <div>{{ o.toString().split(":")[1] }}</div>
                  </div>
                </el-card>
              </div>
              <div style="margin: 0 auto;text-align: center;">
                <el-button @click="submitOrderPay" class="header-row-col-button-success">确定</el-button>
              </div>
            </div>
            <div v-if="radio === 2">
              <vue-qr style="width: 200px;height: 200px;margin-top: 20px" :text="texts" :size="200"></vue-qr>
            </div>
            <el-dialog
              title="提示"
              :visible.sync="SuccessDialog"
              :show-close=false
              :close-on-click-modal=false
              :close-on-press-escape=false
              width="30%"
              center>
              <div style="font-size:18px;text-align: center">{{errorMsgForCode}}<br><span style="color: #FF7052"> {{Second}}秒 </span>后关闭此页面。</div>
            </el-dialog>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>

  import VueQr from 'vue-qr'

  export default {
    name: "orderPaymentType",
    components: {VueQr},
    data() {
      return {
        radio: 1,
        imageUrl: '',
        extra: '',
        fileByte:'',
        fileName:'',
        bankReceiptUrl:'',
        extraData: [],
        file: '',
        sellProductName: '',
        orderData: {
          // effectiveDate: "2021-05-02 00:00:00",
          // orderIdNum: "P2021043000000000422418",
          // payMoney: 2995,
          // orderToken: "IfylbwkPtfjPL9G7zXS/YWa4iAUr6vRB",
          // beShareToken: '6cadf877081a42bdb63482d4884e593e',
          effectiveDate: '',
          orderIdNum: '',
          payMoney: 0,
          orderToken: '',
          beShareToken: '',
        },
        texts: '',
        errorMsgForCode: '',
        SuccessDialog: false,   //控制弹出
        Second: 3,             //设置初始倒计时
        isDisabled: false
      }
    },
    methods: {
      //-- 获取支付参数
      getParameters() {
        let loadingInstance = this.Loading.service({fullscreen: true});
        let that = this;
        this.axios.post('/management/mobileInsuranceInfo/orderPaymentBefore?orderToken=' + encodeURIComponent(decodeURIComponent(this.orderData.orderToken))).then((response) => {
          let data = response.data;
          if (data.success){
            this.orderData = {
              ...this.orderData,
              ...data.datas
            };
            that.axios.post('/management/mobileInsuranceInfo/loadOrderDetail?orderToken='+encodeURIComponent(decodeURIComponent(that.orderData.orderToken)).replace(/%20/g,'%2B').replace(/\+/g,'%2B')).then((response) => {
              let data = response.data;
              if (data.success){
                that.orderData.beShareToken = data.datas.beShareToken;
                that.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                  loadingInstance.close();
                });
              }
            });
          } else {
            this.$message.error(data.msg);
            that.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              loadingInstance.close();
            });
            this.$router.push({name: 'orderManagement', query:{insuranceIsGroup: "4"}})
          }
        });
      },
      // -- 点击查看
      onSee() {
        this.$router.push({name: 'orderDetails', query: {orderToken: this.orderData.orderToken}})
      },
      beforeAvatarUpload(file) {
        if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
          this.$message.error('只能上传png、jpg文件');
          return false;
        }
        const formData = new window.FormData();
        formData.append('file', file);
        formData.append('formType', '30004');
        formData.append('formId', '-1');
        let loadingInstance = this.Loading.service({fullscreen: true});
        this.axios.post('/upload/attachment/uploadFileByComplex',
          formData,
        ).then((response) => {
          let data = response.data;
          if (data.success) {
            this.extra = data.datas.data;
            this.fileByte = data.datas.fileByte;
            this.fileName = data.datas.fileName;
            this.extraData = this.extra.replace(/[?!{}"\[\]]/g, "").split(",");
            this.file = file;
            this.imageUrl = URL.createObjectURL(file);
          } else {
            this.$message.error(data.msg);
          }
        });
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        return false;
      },
      // -- 线下转账提交
      submitOrderPay() {
        // if (!this.$$.isValidObj(this.extra)) {
        //   this.$message.error('请先上传银行回单!');
        //   return;
        // }

        let params = {};

        let loadingInstance = this.Loading.service({fullscreen: true});
        params.orderToken = this.orderData.orderToken;
        params.fileByte = this.fileByte;
        params.fileName = this.fileName;
        // params.clientIP = this.returnCitySN.cip;
        params.extra = this.extra.replace(/[\[]/g,"{").replace(/[\]]/g,"}");
        params.paymentWay = this.orderHelper.orderPaymentServiceType.PAYMENT_TYPE_5;
        params.doComplex_formType = this.orderHelper.payDoComplexFormType.FORM_TYPE_10001;
        this.axios.post('/pay/offlineTransfer', params,
        ).then((response) => {
          let data = response.data;
          if (data.success) {
            this.errorMsgForCode = '转账成功，订单待审核中!';
            this.SuccessDialog = true;
            const that = this;
            const interval = window.setInterval(function () {
              --that.Second;
              if (that.Second === 0) {
                that.SuccessDialog = false;
                window.clearInterval(interval);
                that.sendMsg();
              }
            }, 1000);
          } else {
            this.$message.error(data.msg);
          }
        });
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
      },
      // -- 支付状态轮询校验
      paySuccess() {
        //调取支付状态的接口，支付成功返回200
        this.axios.post('/management/mobileOrderInfoLog/getOrderStatus?orderToken=' + encodeURIComponent(decodeURIComponent(this.orderData.orderToken))
           + '&shareToken='
          + encodeURIComponent(decodeURIComponent(this.orderData.beShareToken)))
          .then((response) => {
            const that = this;
            //注意定时器的this指向问题
            let data = response.data;
            if (data.success) {
              const orderStatus = data.datas.orderStatus;
              if(orderStatus === this.orderHelper.orderStatus.ORDER_STATUS_2){
                this.errorMsgForCode = '支付成功!';
                this.SuccessDialog = true;
                const that = this;
                const interval = window.setInterval(function () {
                  --that.Second;
                  if (that.Second === 0) {
                    that.SuccessDialog = false;
                    window.clearInterval(interval);
                    that.sendMsg();
                  }
                }, 1000);
                clearInterval(that.intervalwx);
                that.intervalwx = null
              }else{
                if(orderStatus === this.orderHelper.orderStatus.ORDER_STATUS_13){
                  clearInterval(that.intervalwx);
                  that.intervalwx = null
                }
              }
            }
          });
      },
      // -- 微信二维码支付链接
      getWxPayCode() {
        if (!this.$$.isValidObj(this.texts) && this.radio === 2) {
          let loadingInstance = this.Loading.service({fullscreen: true});
          if( window.location.host.indexOf(this.$$.constant.client) === -1 ){
            this.texts = this.$$.constant.h5TestClient + "/product/paymentDetail.html?orderToken=" + this.orderData.orderToken + "&beShareToken=" + this.orderData.beShareToken;
          }else {
            this.texts = this.$$.constant.h5Client + "/product/paymentDetail.html?orderToken=" + this.orderData.orderToken + "&beShareToken=" + this.orderData.beShareToken;
          }
          this.intervalwx = window.setInterval(() => {
            setTimeout(this.paySuccess(), 0)
          }, 3000);
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        }
      },
      sendMsg() {
        this.$router.push({name: 'orderManagement', query:{insuranceIsGroup: "4"}})
      },
    },
    destroyed: function () {
      if( this.$$.isValidObj(this.intervalwx) ){
        clearInterval(this.intervalwx);
        this.intervalwx = null;
      }
    },
    mounted() {
      let orderPaymentParams = sessionStorage.getItem('orderPaymentParams');
      if (this.$$.isValidObj(orderPaymentParams)){
        const {orderToken, sellProductName} = JSON.parse(orderPaymentParams);
        this.orderData.orderToken = orderToken;
        this.sellProductName = sellProductName;
        this.getParameters();  //-- 获取支付参数
      }else {
        this.$confirm('当前订单参数错误，请重新进入~', '温馨提示：', {
          showClose: false,
          closeOnClickModal: false,
          center: true,
          showCancelButton: false,
          confirmButtonText: '确认',
        }).then(() => {
          this.$router.push({name: 'orderManagement', query:{insuranceIsGroup: "4"}});
        });
      }
    }
  }
</script>

<style scoped>

  .box-card {
    width: 300px;
    height: auto;
    margin: 10px auto 0;
    text-align: center;
    font-size: 12px;
    color: #333333;
    background: #FFF4F2;
    border-radius: 16px;
  }

  .box-card /deep/ .el-card__body{
    padding: 15px;
  }

  .box-card .item>div{
    display: inline-block;
    line-height: 22px;
  }

  .box-card .item>div:nth-child(1){
    width: 40%;
    text-align: right;
    padding-right: 20px;
    vertical-align: top;
  }

  .box-card .item>div:nth-child(2){
    width: 55%;
    text-align: left;
  }

  .box-card-one {
    width: auto;
    height: auto;
    padding: 20px 0;
    margin: 40px auto 0;
  }

  .box-card-two {
    width: auto;
    height: auto;
    padding: 20px 0;
    margin-bottom: 40px;
  }

  .topUnit{
    margin: 0 auto;
    text-align: center;
  }

  .topUnit>div{
    display: inline-block;
  }

  .bottomUnit{
    width: 100%;
    margin: 0 auto;
    text-align: center;
    font-size: 18px;
    color: #333333;
    font-weight: 500;
  }

  .bottomUnit>div>div{
    margin-bottom: 10px;
  }

  .header-col-p-big {
    font-size: 32px;
    font-weight: 500;
    color: #333333;
  }

  .header-left {
    text-align: left !important;
  }

  .header-col-p-small {
    font-size: 16px;
    font-weight: 400;
    color: #999999;
  }

  .header-col-p-span {
    color: #FF7052;
  }

  .el-icon-circle-check {
    font-size: 64px;
    color: #FF7052;
    vertical-align: top;
    padding-right: 20px;
  }

  .header-row {
    padding-top: 40px;
  }

  .header-radio {
    font-size: 16px;
    font-weight: 400;
  }


  .header-left {
    text-align: left !important;
  }

  .header-row-col-div-span {
    width: 40%;
    padding-right: 20px;
    display: inline-block;
    text-align: right;
    vertical-align: top;
  }

  .header-row-col-div-span + div {
    width: 55%;
    display: inline-block;
    text-align: left;
    vertical-align: initial;
  }

  .header-row-col-div-p {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
  }

  .header-row-col-div-p-big {
    font-size: 24px;
    font-weight: 500;
    color: #333333;
    padding-bottom: 15px;
  }

  .header-row-col-button-success {
    width: 160px;
    background-color: #FF7052;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    margin-top: 30px;
    border-radius: 12px !important;
    border: 0 !important;
  }
</style>

<style scoped>
  .header-radio .el-radio__input.is-checked .el-radio__inner {
    border-color: #FF7052 !important;
    background: #FFFFFF !important;
  }

  .header-radio .el-radio__input.is-checked + .el-radio__label {
    color: #FF7052 !important;
  }

  .header-radio .el-radio__input.is-checked .el-radio__inner:after {
    width: 8px;
    height: 8px;
    background-color: #FF7052 !important;
  }

  .avatar-uploader {
   /* padding-left: 120px;
    margin-top: -25px;*/
  }

  .avatar-uploader .el-upload {
    display: inline-block;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .uploadImg{
    width: 200px;
    height: 200px;
    background: url("../../../../static/images/pay/uploadBackGround.png") no-repeat center /100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/orderPaymentType.vue